<script lang="ts">
  import { onMount } from "svelte";
  import Table from "../../components/Table/Table.svelte";
  import FlexLayout from "../../layout/FlexLayout.svelte";
  import { dashboardExpiringDossierDtoFields } from "../../utils/TableFields/dashboard-expiring-dossier-dto.fields";
  import Chart from "svelte-frappe-charts";
  import {
    dossiersByTypeGlobal,
    dossiersByTypeYear,
    expDossiersloading,
    expDossiersRecords,
    loadDashboard,
    numRecentActivities,
    recentActivitiesDays,
    tiles,
  } from "./dashboard.store";

  onMount(loadDashboard);
</script>

<FlexLayout>
  <div class="dashboard-container">
    <div class="dashboard-sub-horiz">
      {#if !!$tiles}
        <div class="tile is-ancestor dashboard-tiles noselect">
          <div class="tile is-parent">
            <article class="tile is-child box has-text-centered dashboard-pratiche-total">
              <p class="title is-size-1 dashboard-tile-text">
                {$tiles.numTotalDossiers}
              </p>
              <p class="subtitle dashboard-tile-text">pratiche totali</p>
            </article>
          </div>
          <div class="tile is-parent">
            <article class="tile is-child box has-text-centered dashboard-pratiche-current">
              <p class="title is-size-1 dashboard-tile-text">
                {$tiles.numActiveDossiers}
              </p>
              <p class="subtitle dashboard-tile-text">pratiche in corso</p>
            </article>
          </div>
          <div class="tile is-parent">
            <article class="tile is-child box has-text-centered dashboard-pratiche-completed">
              <p class="title is-size-1 dashboard-tile-text">
                {$tiles.numDoneDossiers}
              </p>
              <p class="subtitle dashboard-tile-text">pratiche concluse</p>
            </article>
          </div>
          <div class="tile is-parent">
            <article class="tile is-child box has-text-centered dashboard-pratiche-expiring">
              <p class="title is-size-1 dashboard-tile-text">
                {$tiles.numExpiringDossiers}
              </p>
              <p class="subtitle dashboard-tile-text">
                in scadenza entro {$tiles.numExpiringDays} giorni
              </p>
            </article>
          </div>
        </div>
      {/if}
    </div>

    <div class="dashboard-sub-horiz scrollable" style="flex:1;">
      <div class="box chart-box">
        <h1 class="subtitle has-text-centered">Prossime pratiche per data di scadenza</h1>
        <Table loading={$expDossiersloading} fields={dashboardExpiringDossierDtoFields} records={$expDossiersRecords} />
      </div>
    </div>

    <div class="dashboard-sub-horiz" style="height:250px;">
      <div class="box chart-box chart-padding">
        <h1 class="subtitle has-text-centered">
          Attività degli utlimi {recentActivitiesDays} giorni
        </h1>
        <Chart data={$numRecentActivities} type="bar" colors={["#7799bd"]} animate={false} height="180" />
      </div>

      <!--
      <div class="box chart-box">
        <h1 class="subtitle has-text-centered">
          Pratiche per causale (annuale)
        </h1>
        <Chart
          data={$dossiersByTypeYear}
          type="donut"
          maxSlices="7"
          animate={false}
          height="230"
        />
      </div>
      -->
      <div class="box chart-box">
        <h1 class="subtitle has-text-centered">Pratiche per causale</h1>
        <Chart data={$dossiersByTypeGlobal} type="bar" maxSlices="7" animate={false} height="180" />
      </div>
    </div>
  </div>
</FlexLayout>

<style>
  .dashboard-container {
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
  }
  .dashboard-sub-horiz {
    display: flex;
    flex-direction: row;
    /*flex: 1;*/
    margin-bottom: 0.75rem;
  }
  .dashboard-tiles {
    /*margin-top: 1rem;*/
    padding: 0 0.75rem;
  }
  .dashboard-tile-text {
    color: #f8f8f8;
  }
  .dashboard-pratiche-total {
    background-color: #969696;
  }
  .dashboard-pratiche-current {
    background-color: #eab232;
  }
  .dashboard-pratiche-completed {
    background-color: #1f8659;
  }
  .dashboard-pratiche-expiring {
    background-color: #ca2220;
  }
  .chart-box {
    /*height: 320px;*/
    /*overflow: hidden;*/
    flex: 1;
    padding-top: 1rem;
    padding-right: 1rem;
    margin: 0;
  }
  .scrollable {
    overflow-y: auto !important;
  }
  .chart-padding {
    margin-right: 0.75rem;
  }
</style>
